import TermsOfServiceUpdate from 'library-components/components/TermsOfServiceUpdate/TermsOfServiceUpdate.vue';
import { E_ConfirmResult } from 'library-components/utils/task';
import Vue from 'vue';
const TermsConstructor = Vue.extend(TermsOfServiceUpdate);
let termsDom = null;
export class TrialTermsMsgBoxService {
    constructor({ selector = 'body', i18n }) {
        this.pSelector = 'body';
        this.i18n = null;
        this.pSelector = selector;
        this.i18n = i18n;
    }
    init(isTermsUpdate = false, termsData) {
        termsDom = new TermsConstructor({
            i18n: this.i18n,
            el: document.createElement('div'),
        });
        termsDom.termsUpdate = isTermsUpdate;
        termsDom.termsData = termsData;
        document.querySelector(this.pSelector).appendChild(termsDom.$el);
        return new Promise((resolve, reject) => {
            termsDom.$on('result', (result) => {
                if (result === E_ConfirmResult.CANCEL) {
                    termsDom.$destroy();
                    termsDom.$el.remove();
                    termsDom = null;
                    reject(E_ConfirmResult.CANCEL);
                }
                if (result === E_ConfirmResult.CONFIRM) {
                    resolve(result);
                }
            });
        });
    }
}
